<script setup lang="ts">
const { elementReference, isReady, isRevealed } = useScrollReveal()

const properties = defineProps({
  direction: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  number: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  images: {
    type: Array as () => string[],
    required: true
  },
  mainImage: {
    type: String,
    required: true
  }
})
</script>

<template>
  <div
    ref="elementReference"
    :class="['px-0 py-0 mx-0 my-0', { reveal: isReady, revealed: isRevealed }]"
  >
    <div class="pt-250">
      <v-row class="fill-height" no-gutters>
        <v-col
          cols="0"
          lg="6"
          :order="properties.direction === 'right' ? 0 : 1"
          class="d-none d-lg-block"
        >
          <v-row no-gutters>
            <template v-for="image in images" :key="image">
              <v-col cols="6">
                <NuxtImg
                  class="w-100"
                  :src="image"
                  :alt="`${title} — Projektbild`"
                  loading="lazy"
                />
              </v-col>
            </template>
          </v-row>
          <v-row class="h-50" no-gutters>
            <v-col cols="12">
              <div class="d-flex align-center justify-start h-100 px-12">
                <div>
                  <h3 class="text-primary font-weight-regular bannerTitle mb-6">{{ title }}</h3>
                  <p class="text-body-1">{{ text }}</p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="6" :order="properties.direction === 'right' ? 1 : 0">
          <div class="image-container">
            <NuxtImg
              class="w-100"
              :src="properties.mainImage"
              :alt="`${title} — Hauptbild`"
              loading="lazy"
            />
            <div
              :class="`number-${properties.direction} text-white font-weight-regular`"
              aria-hidden="true"
            >
              0<span class="text-primary">{{ number }}</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="0" order="3">
          <div class="d-flex align-center h-100 px-8 pt-12 d-lg-none">
            <div>
              <h3 class="text-primary font-weight-regular bannerTitle mb-6">{{ title }}</h3>
              <p class="text-body-1">{{ text }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pt-250 {
  padding-top: 180px;
}

.number-right {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 4vw;
  font-size: 25vw;
  line-height: 0;
  z-index: 1;
  opacity: 1;
  transition: opacity 0.5s;
}

.number-left {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 4vw;
  font-size: 25vw;
  line-height: 0;
  z-index: 1;
  opacity: 1;
  transition: opacity 0.5s;
}

@media (min-width: 1264px) {
  .number-right {
    font-size: 12vw;
  }

  .number-left {
    font-size: 12vw;
    right: inherit;
    left: 0;
    margin-left: 4vw;
  }

  .pt-250 {
    padding-top: 250px;
  }
}

.image-container {
  position: relative;
  height: 100%;
}
</style>
